import { Subscriptions } from "@/redux/clients/types/Clients.interface";

export interface loginData {
  username: string;
  password: string;
}

export interface UserResponse {
  id: string;
  username: string;
  name: string;
  role: RolesLevels;
  createdBy?: string;
  position?: string;
  company: string;
  email: string;
  suscripciones?: Subscriptions[];
}

export enum RolesLevels {
  Admin = "Administrador",
  Client = "Cliente",
  MRM = "MRM",
  Creator = "Creator",
}

export interface clients {
  companyid: string;
  folders: string[];
}
